<sd-receipt-type-tabs></sd-receipt-type-tabs>
<sd-receipt-address></sd-receipt-address>

@if (activeReceiptTypeId() === 'delivery') {
  @if (!isAddressListEmptyOrHasError() && isDeliveryAddressValid()) {
    <sd-services></sd-services>
  }

  @if (!isServiceListEmptyOrHasError() && isServicesValid()) {
    <sd-time-slots></sd-time-slots>
  }
}
